import React, { FC, useEffect, useRef, useState } from 'react';
import { useMatchMedia } from '~/src/hooks/use-match-media.hook';
import { MediaWidthEnum } from '~/src/models/enums/media-width.enum';
import { NoSSR } from '~/src/helpers/noSSR.helper';
import { openWindow } from '~/src/helpers/open-window.helper';
import { onSendDocumentClickAnalytics } from './documents-block.analytics';
import DocumentsLogo from '~/src/images/about-products/documents-logo.png';
import { IMAGE_QUALITY } from '~/src/models/constants/image-quality.constants';
import type { CmsDocumentsInterface } from '~/src/models/types/documents.types';
import * as Styled from './documents-block.styles';

interface DocumentsBlockProps {
    documents: CmsDocumentsInterface;
}

export const DocumentsBlock: FC<DocumentsBlockProps> = ({ documents }) => {
    const [isMobileWide] = useMatchMedia(MediaWidthEnum.mobile, { withoutSSR: true });
    const [heightContentContainer, setHeightContentContainer] = useState(0);
    const contentContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (contentContainerRef && contentContainerRef.current) {
            setTimeout(() => {
                const height = contentContainerRef.current?.clientHeight;
                height && setHeightContentContainer(height);
            }, 0);
        }
    }, [contentContainerRef]);

    const handleClick = (url: string, name: string) => {
        onSendDocumentClickAnalytics(name);
        url && openWindow(url);
    };

    return (
        <Styled.DocumentBlockContainer hasToNeedHeight={heightContentContainer <= 24}>
            <NoSSR>
                {!isMobileWide && (
                    <Styled.ImageContainer>
                        <Styled.ImageDocumentsLogo
                            width={177}
                            height={143}
                            alt={'Логотип продукта МТС'}
                            src={DocumentsLogo || ''}
                            priority={true}
                            quality={IMAGE_QUALITY.MEDIUM_HIGH}
                            unoptimized
                        />
                    </Styled.ImageContainer>
                )}
            </NoSSR>
            <Styled.ContentContainer>
                <Styled.DocumentListTitleWrapper>
                    <NoSSR>
                        {isMobileWide && (
                            <Styled.ImageContainer>
                                <Styled.ImageDocumentsLogo
                                    width={59}
                                    height={48}
                                    alt={'Логотип продукта МТС'}
                                    src={DocumentsLogo || ''}
                                    priority={true}
                                    unoptimized
                                />
                            </Styled.ImageContainer>
                        )}
                    </NoSSR>
                    <Styled.DocumentListTitle>Документы</Styled.DocumentListTitle>
                </Styled.DocumentListTitleWrapper>
                <Styled.DocumentList ref={contentContainerRef}>
                    {documents?.value?.map((v) => {
                        return (
                            <Styled.Document key={v.size} onClick={() => handleClick(v.url, v.name)}>
                                {v.name}
                            </Styled.Document>
                        );
                    })}
                </Styled.DocumentList>
            </Styled.ContentContainer>
        </Styled.DocumentBlockContainer>
    );
};
